import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListView } from '../core/ListViewProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { financeiroAtendimentosColumns } from './columns/_columns'
import { AtendimentoList } from '../../../atendimento/core/_models'
import { IconPaths } from '../../../../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'

export const FinanceiroAtendimentosTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { selected } = useListView()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => financeiroAtendimentosColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhum atendimento encontrado'
      description='Revise a instituição, o período e os demais filtros.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      icon={IconPaths.Check}
      title='Nenhum atendimento a faturar'
      description='Todos os atendimentos finalizados já estão em alguma fatura.'
    />
  )

  return (
    <CustomTable<AtendimentoList>
      id='kt_table_atendimentos_nao_faturados'
      ariaLabel={t('title.atendimentos_nao_faturados')}
      itemLabel={{ singular: 'atendimento', plural: 'atendimentos' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      isRowSelected={(row) => selected.includes(row.id)}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
